import { create } from 'zustand'

export const usIsPassProbationStore = create((set) => ({
  isPassProbation: false,
  setIsPassProbation: (isPassProbation) => {
    set({ isPassProbation })
  }
}))
